export default __webpack_public_path__ + "static/media/Q02_百香果、芬多精、淡淡蜜桃、白色花香氣.eb34bb46.mp4";